import React from "react";
import FinanceDetailsDialog from "../../../components/FinanceDetails/FinanceDetailsDialog";
import { PeriodTypes, ShortMonths } from "../../../../../../data/dates";
import PropTypes from "prop-types";
import { RevenueTypes } from "../../../../../../components/constants/finance";
import Revenue_SingleQuantity from "../../../../../../data/Finance/Revenue/Revenue_SingleQuantity";

class UnitSales extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      revenue: this.props.revenue,
      data: null,
      rows: [],
      monthlyChartData: null,
      yearlyChartData: null,
      itemChanged: false,
    };

    this.monthHeaders = global.Modeliks.DateHelper.months;
    this.yearHeaders = global.Modeliks.DateHelper.gridPeriodHeaders_Years();
    this.gridHeaders = [...this.monthHeaders, ...this.yearHeaders];

    this.tabs = [
      {
        title: this.state.revenue.UnitSales.Name,
        subtitle: `${this.state.revenue.UnitSales.Name}`,
        field: "Quantity",
        description: "Unit Sales is the number of units of product you plan to sell.",
        growthEnabled: true,
        childrenFunc: this.renderText,
        checkedGrowth: false,
        changeEnabled: true,
        allowDisplayActuals: true,
        showActuals: false,
        changeDriverNameEnabled: true,
        dataGridRow: {
          data: this.state.revenue.UnitSales,
          drivers: [],
        },
        chart: {
          monthlyChartData: {
            data: this.state.revenue.UnitSales.Values.filter(
              (c) => this.monthHeaders.indexOf(c.Date) > -1,
            ),
            labels: global.Modeliks.DateHelper.headers_Months(),
          },
          yearlyChartData: {
            data: this.state.revenue.UnitSales.Values.filter(
              (c) => this.yearHeaders.indexOf(c.Date) > -1,
            ),
            labels: global.Modeliks.DateHelper.headers_Years(true),
          },
        },
      },
      {
        title: this.state.revenue.UnitPrices.Name,
        subtitle: `${this.state.revenue.UnitPrices.Name}`,
        field: "SinglePrice",
        description: "Unit price is the price at which you plan to sell each Unit of this product.",
        growthEnabled: true,
        checkedGrowth: false,
        changeEnabled: true,
        allowDisplayActuals: true,
        showActuals: false,
        changeDriverNameEnabled: true,
        dataGridRow: {
          data: this.state.revenue.UnitPrices,
          drivers: [],
        },
        chart: {
          monthlyChartData: {
            data: this.state.revenue.UnitPrices.Values.filter(
              (c) => this.monthHeaders.indexOf(c.Date) > -1,
            ),
            labels: global.Modeliks.DateHelper.headers_Months(),
          },
          yearlyChartData: {
            data: this.state.revenue.UnitPrices.Values.filter(
              (c) => this.yearHeaders.indexOf(c.Date) > -1,
            ),
            labels: global.Modeliks.DateHelper.headers_Years(true),
          },
        },
      },
    ];
  }

  componentDidMount() {}
  renderText = () => {
    // return <p>Unit Sales is the number of units of product you plan to sell.</p>
  };

  onSave = () => {
    this.props.saveRevenue();
  };

  onDataChanged = (items) => {
    // items.forEach(item=>{
    //     if(item.cache){
    //         item.cache.resetCache();
    //     }
    // })
    this.setState({ itemChanged: true });
  };

  render = () => {
    if (this.state.revenue == null) {
      return null;
    }

    return (
      <FinanceDetailsDialog
        addTab={this.addTab}
        open={this.props.open}
        title={this.state.revenue.RevenueName}
        tabs={this.tabs}
        headers={this.gridHeaders}
        monthlyChartData={this.state.monthlyChartData}
        yearlyChartData={this.state.yearlyChartData}
        saveEnabled={this.state.itemChanged}
        setFormula={this.setFormula}
        onSave={this.onSave}
        onClose={this.props.onClose}
        totalDriver={this.props.totalDriver}
        table={this.state.revenue.tableName}
        parentID={this.state.revenue.ID}
        onGeneral={this.props.onGeneral}
        onDataChanged={this.onDataChanged}
        tabIndex={this.props.tabIndex}
      />
    );
  };
}

UnitSales.propTypes = {
  revenue: PropTypes.object,
  onGeneral: PropTypes.func,
  onClose: PropTypes.func,
};

export default UnitSales;
